import { Contract } from 'web3-eth-contract';

export function decodeMethodResult(contract: Contract, methodName: string, data: string) {
    const typeDefine = (contract as any)._jsonInterface.filter((a: any) => a['name'] === methodName)[0].outputs;
    return (contract as any)._decodeMethodReturn(typeDefine, data);
}
